import { render, staticRenderFns } from "./hzWeChat.vue?vue&type=template&id=22cde3bd&scoped=true"
import script from "./hzWeChat.vue?vue&type=script&lang=js"
export * from "./hzWeChat.vue?vue&type=script&lang=js"
import style0 from "./hzWeChat.vue?vue&type=style&index=0&id=22cde3bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cde3bd",
  null
  
)

export default component.exports